import { ButtonLink, ButtonModal } from "../../../../components";
import { TEMPLATE } from "../../../../constants";
import { handleMark } from "./functions";

const { MODAL_ACTION } = TEMPLATE.MODAL;

export const ActionItems = (
  record, 
  setIsOpenEdit,
  setData,
  setIsOpenRemark,
  dispatch, 
  messageApi,
  user 
) => {
  
  const { status } = record;

  return [
    {
      key: 0,
      label: <ButtonLink>Edit</ButtonLink>,
      onClick: () => {
        setIsOpenEdit(true);
        setData(record);
      },
    },
    {
      key: 1,
      label:
        status === 1 || status === 0 ? (
          <>Mark as active</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_active_company}
            onClick={() => handleMark(record, "active", dispatch, messageApi, user)}
            extra={record}
          >
            Mark as active
          </ButtonModal>
        ),
      disabled: status === 1 || status === 0,
    },
    {
      key: 2,
      label:
        status === 2 || status === 0 ? (
          <>Mark as suspended</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_suspended_company}
            onClick={() => handleMark(record, "suspended", dispatch, messageApi, user)}
            extra={record}
          >
            Mark as suspended
          </ButtonModal>
        ),
      disabled: status === 2 || status === 0,
    },
   
    {
      key: 5,
      label: <ButtonLink>Add remarks</ButtonLink>,
      onClick: () => {
        setIsOpenRemark(true);
        setData(record);
      },
    },
  ];
};
